import { OneTrustCookieCategories } from '@components/Vendors/Vendors';
import { LOCALSTORAGE_COOKIE_CONSENT } from '@constants/localStorage';
import getWindowPropertySafely from '@utils/getWindowPropertySafely';

const getCookieConsent: (property: OneTrustCookieCategories) => boolean = (
  property,
) => {
  const cookieConsent =
    getWindowPropertySafely<'OnetrustActiveGroups'>('OnetrustActiveGroups') ??
    getWindowPropertySafely<'localStorage'>('localStorage')?.getItem(
      LOCALSTORAGE_COOKIE_CONSENT,
    ) ??
    '';

  return cookieConsent.includes(property) || false;
};

export default getCookieConsent;
